import { Link } from 'react-router-dom';
import useImageUrl from 'hooks/useImageUrl';
import routeNames from 'router/routeNames.json';
import { PriceTag } from './common/PriceTag';

export const ProductItem = ({
  product,
  showFooter,
  showDiscount,
  link,
  type,
}) => {
  const constructImageUrl = useImageUrl();

  return (
    <div className="relative">
      <PriceTag
        className="absolute top-0 right-0"
        size="medium"
        price={product.price}
        showDiscount={showDiscount}
        type={type}
      />

      <Link to={link} className="block w-full overflow-hidden">
        <img
          src={constructImageUrl({
            img: product.zoom,
            width: 285,
            height: 342,
          })}
          alt={product.name}
          className="w-full h-auto"
          width="285px"
          height="342px"
        />
      </Link>

      {showFooter && (
        <footer className="px-2 bg-qw-blue-500 text-white text-center leading-tight font-sans truncate absolute bottom-0 w-full">
          <Link
            to={link}
            className="font-bold text-lg hover:text-white hover:underline"
          >
            {product.name}
          </Link>
          <p className="italic">
            by{' '}
            <Link
              className="font-bold text-white hover:text-white hover:underline"
              to={`${routeNames.profile}/${product.user?.id}`}
            >
              {product.user?.username}
            </Link>
          </p>
        </footer>
      )}
    </div>
  );
};
